export const getStatusColor = (status) => {
    switch (status) {
        case "COMPLETED":
        case "DONE":
            return "bg-green-100 text-green-800 border-green-200";
        case "IN_PROGRESS":
        case "STARTED":
            return "bg-blue-100 text-blue-800 border-blue-200";
        case "DRIVING":
            return "bg-yellow-100 text-yellow-800 border-yellow-200";
        case "ARRIVED":
            return "bg-purple-100 text-purple-800 border-purple-200";
        default:
            return "bg-gray-100 text-gray-800 border-gray-200";
    }
};
